import { WebVTTParser } from "webvtt-parser";
import { decodeBase64ToUtf8 } from "@/react/helpers/base64Utils";

export const isWebVttValid = (value: string) => {
  if (!value) return true;

  const vttText = decodeBase64ToUtf8(value);
  const parser = new WebVTTParser();
  const result = parser.parse(vttText);

  return !result?.errors?.length;
};
